(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["claude-hair-demo-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  const selector = '[data-review-section]';
  if (window.__purefemmReviewBlocks) {
    window.__purefemmReviewBlocks.mountAll();
    return;
  }
  const states = new WeakMap();
  const formatter = new Intl.NumberFormat('de-DE');

  function mount(root) {
    if (states.has(root)) return;
    const list = root.querySelector('[data-lxs]');
    const button = root.querySelector('[data-lxmore]');
    const counter = root.querySelector('[data-lxcount]');
    const totalLabel = root.querySelector('[data-lxtotal-label]');
    if (!list || !button || !counter || !totalLabel) return;
    const originals = Array.from(list.querySelectorAll('.hr4-lx'));
    if (!originals.length) {
      button.hidden = true;
      totalLabel.textContent = '0';
      return;
    }
    const total = Math.max(originals.length, Math.min(5000, Number(root.dataset.lxtotal) || originals.length));
    const batchSize = Math.max(1, Math.min(48, Number(root.dataset.lxbatch) || 24));
    const initialCount = root.dataset.reviewEditor === 'true' ? originals.length : Math.max(1, Math.min(24, Number(root.dataset.lxinitial) || 10));
    const unit = root.dataset.reviewLabel || '';
    function renderText(template) {
      const values = { count: formatter.format(Math.min(batchSize, total - shown)), shown: formatter.format(shown), total: formatter.format(total), label: unit };
      return template.replace(/\[(count|shown|total|label)\]/g, (_, key) => values[key]);
    }
    let shown = 0;

    function appendBatch(size) {
      const end = Math.min(shown + size, total);
      const fragment = document.createDocumentFragment();
      for (let i = shown; i < end; i++) {
        const card = i < originals.length ? originals[i] : originals[i % originals.length].cloneNode(true);
        if (i >= originals.length) {
          card.removeAttribute('data-shopify-editor-block');
          card.removeAttribute('data-block-id');
        }
        fragment.appendChild(card);
      }
      list.appendChild(fragment);
      shown = end;
      counter.textContent = renderText(root.dataset.counterTemplate || '');
      button.hidden = shown === total;
      if (!button.hidden) button.textContent = renderText(root.dataset.moreTemplate || '');
    }

    list.replaceChildren();
    list.classList.add('all');
    totalLabel.textContent = formatter.format(total);
    counter.hidden = false;
    appendBatch(initialCount);
    button.addEventListener('click', () => appendBatch(batchSize));
    states.set(root, {
      selectBlock(blockId) {
        const index = originals.findIndex(card => card.dataset.blockId === blockId);
        if (index < 0) return;
        if (shown <= index) appendBatch(index + 1 - shown);
        requestAnimationFrame(() => list.children[index].scrollIntoView({ block: 'center', behavior: 'auto' }));
      }
    });
  }

  function mountAll() {
    document.querySelectorAll(selector).forEach(mount);
  }

  function rootFor(sectionId) {
    return Array.from(document.querySelectorAll(selector)).find(root => root.dataset.reviewSection === sectionId);
  }

  document.addEventListener('shopify:section:load', mountAll);
  document.addEventListener('shopify:section:reorder', mountAll);
  document.addEventListener('shopify:section:unload', event => {
    const root = event.target.querySelector(selector);
    if (root) states.delete(root);
  });
  document.addEventListener('shopify:section:select', event => {
    const root = rootFor(event.detail.sectionId);
    if (root) requestAnimationFrame(() => root.scrollIntoView({ block: 'start', behavior: 'auto' }));
  });
  document.addEventListener('shopify:block:select', event => {
    const root = rootFor(event.detail.sectionId);
    if (!root) return;
    mount(root);
    const state = states.get(root);
    if (state) state.selectBlock(event.detail.blockId);
  });
  window.__purefemmReviewBlocks = { mountAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll, { once: true });
  else mountAll();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["claude-hair-results"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__purefemmHairResults) { window.__purefemmHairResults.initAll(); return; }
  function init(root) {
  if (root.dataset.hr4Ready) return;
  root.dataset.hr4Ready = "true";
  var q = new URLSearchParams(location.search), store = {};
  try { store = JSON.parse(sessionStorage.getItem("hr4") || "{}"); } catch (e) {}
  function v(k, ok) { var x = q.get(k) || store[k]; return x && (!ok || ok.test(x)) ? x : null; }
  var p = { ha: v("ha", /^(sl|sc|ok|ue)$/), hs: v("hs", /^[1-4]$/), hm: v("hm", /^[a-z0-9,]+$/) };
  try { sessionStorage.setItem("hr4", JSON.stringify(p)); } catch (e) {}
  if (p.ha) root.setAttribute("data-ha", p.ha);
  if (p.hs) root.setAttribute("data-hs", p.hs);
  var tried = p.hm && p.hm !== "0" ? p.hm.split(",") : null;
  [].forEach.call(root.querySelectorAll(".hr4-why"), function (el) {
    var show = tried ? tried.indexOf(el.getAttribute("data-hm")) > -1 : el.getAttribute("data-def") === "1";
    el.style.display = show ? "" : "none";
  });
  var first = root.querySelector('.hr4-why:not([style*="none"])'); if (first) first.classList.add("open");
  [].forEach.call(root.querySelectorAll(".hr4-s"), function (b) {
    b.setAttribute("aria-expanded", b.parentNode.classList.contains("open") ? "true" : "false");
    b.addEventListener("click", function (e) { e.preventDefault(); var d = b.parentNode; d.classList.toggle("open"); b.setAttribute("aria-expanded", d.classList.contains("open") ? "true" : "false"); });
  });
  var cta = root.querySelector("[data-hr4-cta]");
  [].forEach.call(root.querySelectorAll(".hr4-opt"), function (o) {
    o.addEventListener("click", function () {
      [].forEach.call(root.querySelectorAll(".hr4-opt"), function (x) { x.classList.remove("is-on"); });
      o.classList.add("is-on"); o.querySelector("input").checked = true;
      if (cta) {
        var u = new URL(o.getAttribute("data-link"), location.href);
        ["cpid", "cid"].forEach(function (k) { if (q.get(k)) u.searchParams.set(k, q.get(k)); });
        cta.setAttribute("href", u.toString());
      }
    });
  });
  var gal = root.querySelector("[data-hr4-gal]");
  if (gal) {
    var view = gal.querySelector(".hr4-gal__v"), th = gal.querySelectorAll(".hr4-gal__t button");
    [].forEach.call(th, function (b, i) { b.addEventListener("click", function () { view.scrollTo({ left: i * view.clientWidth, behavior: "smooth" }); }); });
    view.addEventListener("scroll", function () { var i = Math.round(view.scrollLeft / view.clientWidth); [].forEach.call(th, function (b, k) { b.classList.toggle("on", k === i); }); }, { passive: true });
  }
  var more = root.querySelector("[data-hr4-more]"), rvs = root.querySelector("[data-hr4-rvs]");
  if (more && rvs) more.addEventListener("click", function () { rvs.classList.add("all"); more.style.display = "none"; });

  }
  function updateSticky() {
    var off = document.querySelector('[data-hr4-part="results"] .hr4-acc');
    document.querySelectorAll('[data-hr4-sticky]').forEach(function (sticky) {
      sticky.classList.toggle('on', Boolean(off && off.getBoundingClientRect().top < 0));
    });
  }
  function initAll() {
    document.querySelectorAll('[data-hr4-part]').forEach(init);
    updateSticky();
  }
  window.__purefemmHairResults = { initAll: initAll };
  document.addEventListener('shopify:section:load', initAll);
  window.addEventListener('scroll', updateSticky, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
